<template>
  <div class="mb-4 mb-md-5">
    <router-link to="/" class="d-block auth-logo">
      <img
          src="@/assets/images/logo-dark.png"
          alt=""
          height="32"
          class="auth-logo-dark"
      />
      <img
          src="@/assets/images/logo-light.png"
          alt=""
          height="32"
          class="auth-logo-light"
      />
    </router-link>
  </div>

</template>

<script>
export default {
  name: "LoginHeader"
}
</script>

<style scoped>

</style>